import { CorporationDataType } from '@commenda/types/src/corporation';
import {
  DirectorBase,
  TValidateStakeholdersResponse,
} from '@commenda/types/src/incorporation/types';
import { getCorporationName } from '@commenda/utils';
import { StakeholderType } from '@prisma/client';
import { ZodError } from 'zod';
import { corporationDetailsSchema } from '../../common/corporateStakeholder/CorporationDetailsForm';
import { getDirectorName } from '../../Director/common';
import { TShareholderVsSharePercentageMap } from '../../EquityInfo/types';
import { validateIndividualDirector } from '../components/modals/IndividualDirectorForm/validators';

export const validateStakeholders = (
  selectedStakeholders: TShareholderVsSharePercentageMap,
  {
    directors,
    corporations,
  }: { directors: DirectorBase[]; corporations: CorporationDataType[] }
): TValidateStakeholdersResponse[] => {
  const shareholderWithError: TValidateStakeholdersResponse[] = [];

  Object.keys(selectedStakeholders).forEach((stakeholderId) => {
    const [type, id] = stakeholderId.split('_');

    if (type === StakeholderType.INDIVIDUAL) {
      const director = directors.find((d) => d.id === +id);

      if (!director) return;

      const validateDirectorResult = validateIndividualDirector(director);

      if (!validateDirectorResult.success) {
        shareholderWithError.push({
          name: getDirectorName(director),
          id: stakeholderId,
        });
      }
    }

    if (type === StakeholderType.INSTITUTION) {
      const corporation = corporations.find((c) => c.id === +id);

      if (!corporation) return;

      const corporationBasicInformationValidationResult =
        corporationDetailsSchema.safeParse(corporation) as {
          success: boolean;
          error: ZodError;
        };

      if (!corporationBasicInformationValidationResult.success) {
        if (corporationBasicInformationValidationResult.error) {
          shareholderWithError.push({
            name: getCorporationName(corporation),
            id: stakeholderId,
          });
        }
      }
    }
  });

  return shareholderWithError;
};
